import {
  type PaginationState,
  type SortingState,
} from '@tanstack/react-table'
import { useState } from 'react'

import { type AdminEmployer } from 'utils/web_api.schemas'

import EmployerReviewFilters, {
  type EmployerFilterGroupType,
  filterConfigurations,
} from './EmployerReviewFilters'
import EmployerReviewsQuickFilters from './EmployerReviewsQuickFilters'
import EmployerReviewsTable, { type EmployerFilters } from './EmployerReviewsTable'
import SyncFiltersWithURL from './SyncFiltersWithUrl'

const EmployerReviewsView = () => {
  const [filters, setFilters] = useState<EmployerFilters>({})
  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 1,
    pageSize: 20,
  })
  const [sorting, setSorting] = useState<SortingState>([
    { id: 'created_at', desc: true },
  ])

  return (
    <div className='flex-col w-full h-full p-4 space-y-4 bg-white rounded-lg max-w-[2000px] mx-auto'>
      <div className='flex items-center justify-between w-full mb-4 gap-x-2'>
        <div className='text-2xl font-semibold w-96'>Employer Reviews</div>
      </div>
      <SyncFiltersWithURL<
        EmployerFilters,
        AdminEmployer,
        EmployerFilterGroupType
      >
        filters={filters}
        pagination={pagination}
        setFilters={setFilters}
        defaultFilters={{ review_statuses: ['pending'] }}
        sortableKeys={['created_at', 'review_status']}
        filterConfigurations={filterConfigurations}
      />
      <EmployerReviewsQuickFilters
        filters={filters}
        setFilters={setFilters}
      />
      <EmployerReviewFilters
        filters={filters}
        setFilters={setFilters}
        pagination={pagination}
        setPagination={setPagination}
      />
      <EmployerReviewsTable
        filters={filters}
        setFilters={setFilters}
        pagination={pagination}
        setPagination={setPagination}
        sorting={sorting}
        setSorting={setSorting}
      />
    </div>
  )
}

export default EmployerReviewsView
